import type { TierDefaults } from '../types/tier-limits';

export const FALLBACK_TIER_DEFAULTS: TierDefaults = {
  free: {
    maxProjects: 2,
    maxDocumentsPerProject: 2,
    maxResourcesPerProject: 2,
    initialCredits: 1000,
    monthlyCreditsRefill: 0,
    storageQuotaMB: 10,
    versionHistoryDays: 7,
  },
  pro: {
    maxProjects: null,
    maxDocumentsPerProject: null,
    maxResourcesPerProject: null,
    initialCredits: 3000,
    monthlyCreditsRefill: 3000,
    storageQuotaMB: 1024,
    versionHistoryDays: null,
  },
  editorial: {
    maxProjects: null,
    maxDocumentsPerProject: null,
    maxResourcesPerProject: null,
    initialCredits: 5000,
    monthlyCreditsRefill: 5000,
    storageQuotaMB: 5 * 1024,
    versionHistoryDays: null,
  },
};
